<template>
  <el-dialog class="bill-dialog" title="账单详情" :visible="visible" :show-close="false">
    <el-row :gutter="20">
      <el-col :span="8" class="label">单据编号</el-col>
      <el-col :span="16">{{ bill.bill_no }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">租赁车辆</el-col>
      <el-col :span="16">{{ bill.company_name }} {{ bill.car_alias }} {{ bill.licnum }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">安全员</el-col>
      <el-col :span="16">{{ bill.secu_name }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">教练员</el-col>
      <el-col :span="16">{{ bill.coach_name }}</el-col>
    </el-row>
    <el-row :gutter="20" v-for="stu in students" :key="stu.id">
      <el-col :span="8" class="label">学员</el-col>
      <el-col :span="4">{{ stu.name }}</el-col>
      <el-col :span="12">{{ stu.idcard }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">开始时间</el-col>
      <el-col :span="16">{{ bill.start_time }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">结束时间</el-col>
      <el-col :span="16">{{ bill.end_time }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">用车时长</el-col>
      <el-col :span="16">{{ bill.use_time }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">计费方式</el-col>
      <el-col :span="16">{{ bill.price_type }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">单价</el-col>
      <el-col :span="16">{{ bill.price }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">应收费用</el-col>
      <el-col :span="16">{{ bill.fee }}元</el-col>
    </el-row>
    <el-row :gutter="20" v-if="bill.min_fee > 0">
      <el-col :span="8" class="label">保底消费</el-col>
      <el-col :span="16">{{ bill.min_fee }}</el-col>
    </el-row>
    <el-row :gutter="20" v-if="bill.fee_discount > 0">
      <el-col :span="8" class="label">优惠</el-col>
      <el-col :span="16">{{ bill.fee_discount }}</el-col>
    </el-row>
    <el-row :gutter="20" v-if="bill.discount_rate > 0">
      <el-col :span="8" class="label">折扣率</el-col>
      <el-col :span="16">{{ bill.discount_rate }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">实收金额</el-col>
      <el-col :span="16">
        <div>{{ bill.pay_total }}元</div>
        <el-row :gutter="20" v-if="bill.pay_cash > 0">
          <el-col :span="6">├ 现金</el-col>
          <el-col :span="18">{{ bill.pay_cash }}元</el-col>
        </el-row>
        <el-row :gutter="20" v-if="bill.pay_alipay > 0">
          <el-col :span="6">├ 支付宝</el-col>
          <el-col :span="18">{{ bill.pay_alipay }}元</el-col>
        </el-row>
        <el-row :gutter="20" v-if="bill.pay_wechat > 0">
          <el-col :span="6">├ 微信支付</el-col>
          <el-col :span="18">{{ bill.pay_wechat }}元</el-col>
        </el-row>
        <el-row :gutter="20" v-if="bill.pay_pos > 0">
          <el-col :span="6">├ 银行卡</el-col>
          <el-col :span="18">{{ bill.pay_pos }}元</el-col>
        </el-row>
        <el-row :gutter="20" v-for="card in cards" :key="card.id">
          <el-col :span="6">├ 充值卡</el-col>
          <el-col :span="4">{{ card.oper_money }}元</el-col>
          <el-col :span="14">{{ card.card_no }}</el-col>
        </el-row>
        <el-row :gutter="20" v-for="coupon in coupons" :key="coupon.id">
          <el-col :span="6">├ 代金券</el-col>
          <el-col :span="4">{{ coupon.coupon_money }}元</el-col>
          <el-col :span="14">{{ coupon.coupon_no }}</el-col>
        </el-row>
        <el-row :gutter="20" v-if="bill.pay_virtual > 0">
          <el-col :span="6">├ 挂账</el-col>
          <el-col :span="18">{{ bill.pay_virtual }}元</el-col>
        </el-row>
        <el-row :gutter="20" v-if="bill.pay_advance > 0">
          <el-col :span="6">├ 预收</el-col>
          <el-col :span="18">{{ bill.pay_advance }}元</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">培训线路</el-col>
      <el-col :span="16">{{ bill.route_name }}</el-col>
    </el-row>
    <!--
    <el-row :gutter="20">
      <el-col :span="8" class="label">培训服务</el-col>
      <el-col :span="16">{{ bill.exam_service }}</el-col>
    </el-row>
    -->
    <el-row :gutter="20" v-if="bill.sales_name !== '无'">
      <el-col :span="8" class="label">业务员</el-col>
      <el-col :span="16">{{ bill.sales_name }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">操作员</el-col>
      <el-col :span="16">{{ bill.oper_name }}</el-col>
    </el-row>
    <el-row :gutter="20" v-if="bill.remark">
      <el-col :span="8" class="label">备注</el-col>
      <el-col :span="16">{{ bill.remark }}</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" class="label">单据状态</el-col>
      <el-col :span="16">{{ bill.status }}</el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="print">打印单据</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    billId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bill: {
        company_name: '',
        bill_no: '',
        car_alias: '',
        licnum: '',
        status: '',
        pay_status: '',
        secu_name: '',
        coach_name: '',
        school_name: '',
        start_time: '',
        end_time: '',
        use_time: 0,
        price_type: '',
        price: 0,
        fee: 0,
        fee_discount: 0,
        discount_rate: 0,
        pay_total: 0,
        pay_cash: 0,
        pay_alipay: 0,
        pay_virtual: 0,
        pay_advance: 0,
        pay_wechat: 0,
        pay_pos: 0,
        pay_balance: 0,
        pay_coupon: 0,
        route_name: '',
        exam_service: '',
        sales_name: '',
        oper_name: '',
        remark: ''
      },
      students: [],
      cards: [],
      coupons: []
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetch()
      }
    }
  },
  methods: {
    fetch () {
      this.bill = {
        company_name: '',
        bill_no: '',
        car_alias: '',
        licnum: '',
        status: '',
        pay_status: '',
        secu_name: '',
        coach_name: '',
        school_name: '',
        start_time: '',
        end_time: '',
        use_time: 0,
        price_type: '',
        price: 0,
        fee: 0,
        fee_discount: 0,
        discount_rate: 0,
        pay_total: 0,
        pay_cash: 0,
        pay_alipay: 0,
        pay_virtual: 0,
        pay_advance: 0,
        pay_wechat: 0,
        pay_pos: 0,
        pay_balance: 0,
        pay_coupon: 0,
        route_name: '',
        exam_service: '',
        sales_name: '',
        oper_name: '',
        remark: ''
      }
      this.students = []
      this.cards = []
      this.coupons = []
      this.$http.get('/dbapi/bill_list?id=' + this.billId).then(response => {
        if (response.data.success) {
          if (response.data.list.length > 0) {
            this.bill = response.data.list[0]
            // 学员列表
            this.$http.get('/dbapi/student_list?bill_id=' + this.billId).then(response => {
              this.students = response.data.list
            })
            // 充值卡列表
            if (this.bill.pay_balance > 0) {
              this.$http.get('/dbapi/bill_pay_cards?id=' + this.billId).then(response => {
                this.cards = response.data.list
              })
            }
            // 代金券列表
            if (this.bill.pay_coupon > 0) {
              this.$http.get('/dbapi/bill_pay_coupons?id=' + this.billId).then(response => {
                this.coupons = response.data.list
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: '没有找到账单信息'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    close () {
      this.$emit('close')
    },
    print () {
      // if (this.bill.pay_coupon == this.bill.pay_total) {
      //   window.open(this.$http.receiptBaseUrl + '/bill_print_coupon?id=' + this.billId + '&token=' + localStorage.getItem('kaochang.token'))
      // } else {
        window.open(this.$http.receiptBaseUrl + '/bill_print?id=' + this.billId + '&token=' + localStorage.getItem('kaochang.token'))
      // }
    }
  }
}
</script>

<style scoped>
.bill-dialog .label {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/BillDialog.vue